<template>
  <b-row>
    <reject v-if="reject" :lead="lead" @cancel="reject=false" @close="$emit('close')" @rejected="leadRejected" />

    <b-col v-else-if="busy" class="text-center">
      <spinner />
    </b-col>

    <b-col v-else class="col-12 fadein-details">
      <b-alert variant="danger" :show="error!==false" class="my-2" v-html="error" />
      <b-row v-if="error===false">
        <b-col>
          <b-row v-if="!block" class="mb-3">
            <template v-if="!accepted">
              <b-col class="col-12 px-0 fadein-details">
                <div class="buy-lead p-3 rounded">
                  <b-row>
                    <b-col>
                      <p class="mb-3 small">
                        <i18n path="buyLeadsConfirm">
                          <template v-slot:price>
                            {{ $n(lead.dashboardPrice, 'currency') }}
                          </template>
                          <template v-slot:plusVat>
                            <small class="vat-text text-reset">{{ $t('+ VAT') }}</small>
                          </template>
                        </i18n>
                      </p>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="col-12 d-flex justify-content-center lead-actions">
                      <b-button class="mr-1" size="sm" variant="outline-secondary" @click.prevent.stop="$emit('close')">
                        {{ $t('Cancel') }}
                      </b-button>
                      <b-button class="ml-1" size="sm" variant="primary"
                                :disabled="!canPayForLeads" @click.prevent.stop="(agree=true) && buyLead()"
                      >
                        <span id="buy-lead-cta" v-b-tooltip:hover>{{ $t('Buy Lead CTA') }}</span>
                      </b-button>
                      <b-tooltip v-if="!canPayForLeads" target="buy-lead-cta">
                        {{ $t('Please add a card') }}
                        <router-link :to="{ path: '/help/contact' }">
                          {{ $t('here') }}
                        </router-link>
                      </b-tooltip>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </template>
            <template v-else>
              <b-col class="col-12 px-0 pb-3 fadein-details">
                <div class="buy-lead d-md-flex align-items-center my-md-2 px-md-3 py-3 py-md-2 rounded h-100">
                  <div class="float-md-left col-12 col-md-8 align-items-center d-flex buy-lead__bought">
                    <div class="text-center text-md-left w-100">
                      <h2 class="h4">
                        {{ $t('Thank you for your purchase.') }}
                      </h2>
                      <i18n path="myLeadsMsg" tag="p" class="h4 font-weight-light h5">
                        <template v-slot:myLeadsLink>
                          <router-link class="text-link text-reset" :to="{name:'my-leads'}">
                            {{ $t('myLeadsLink') }}
                          </router-link>
                        </template>
                      </i18n>
                    </div>
                  </div>
                  <div class="float-md-left col-12 col-md-4 align-items-center text-center lead-actions lead-actions-bought">
                    <a
                      v-if="!isMobile"
                      class="btn d-none d-inline-block btn-outline-secondary btn-sm mt-2"
                      :href="printUrl" target="_blank"
                    >
                      <font-awesome-icon class="mr-2" :icon="'print'" />{{ $t('Print') }}
                    </a>
                    <router-link class="btn btn-outline-secondary btn-sm mt-2" :to="{name:'my-lead', params: {code: acceptedLead.code}}">
                      {{ $t('View Lead') }}
                    </router-link>
                  </div>
                </div>
              </b-col>
            </template>
          </b-row>
          <b-row v-if="single" class="fadein-details">
            <b-col class="align-self-center text-center pb-3">
              <h2>{{ lead.work_type_translation }}</h2>
              <h3 class="h5 mb-0">
                {{ leadShortAddress(lead.location, lead[0].postcode) }}
              </h3>
            </b-col>
          </b-row>
          <enquirer-details v-if="accepted" class="fadein-details" :lead="acceptedLead" />
          <b-row class="fadein-details">
            <b-col class="pb-4">
              <strong>{{ $t('Qualification notes:') }}</strong> {{ lead[0].description }}
            </b-col>
          </b-row>
          <enquiry-questions class="mb-4 fadein-details" :questions="questions" :lead="lead" :accepted="accepted" />
          <b-row class="fadein-details">
            <b-col class="position-relative d-flex">
              <template v-if="!accepted && !block">
                <b-button
                  v-if="!busy"
                  variant="empty"
                  class="text-link align-self-center text-link-no-thanks position-absolute"
                  @click.prevent.stop="reject = true"
                >
                  {{ $t('No Thanks') }}
                </b-button>
              </template>
              <div v-if="lead" class="flex-wrap m-auto d-flex align-content-center flex-column justify-content-center" @click.prevent.stop="$emit('close')">
                <b-button class="close m-auto" variant="link">
                  <font-awesome-icon icon="times" />
                </b-button>
                <b-button variant="ghost" class="close-text p-0 m-0">
                  {{ $t('Close') }}
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
import Spinner from "@/components/animation/Spinner";
import EnquirerDetails from "@/components/list/EnquirerDetails";
import EnquiryQuestions from "@/components/list/EnquiryQuestions";
import LeadsSoldMixin from "@/imports/mixins/leadsSold";
import Reject from "@/components/pane/Reject";
import {ACTIONED_LEADS} from "@/store/leads/mutation-types";
import LeadShortAddressMixin from "@/imports/mixins/leadShortAddress";
import userDevice from "@/imports/mixins/userDevice";
import gaEvent from "@/imports/mixins/gaEvent";
import gaTransaction from "@/imports/mixins/gaTransaction";
import companyAccount from "@/imports/mixins/companyAccount";

export default {
  name: "BuyLead",
  components: {Reject, EnquiryQuestions, EnquirerDetails, Spinner},
  mixins:[LeadsSoldMixin, LeadShortAddressMixin, userDevice, gaEvent, gaTransaction, companyAccount],
  props: ['lead', 'single', 'block'],
  data: function() {
    return {
      questions: [],
      agree: false,
      busy: false,
      error: false,
      acceptedLead: null,
      reject: false,
    }
  },
  computed: {
    buyDisabled: function() {
      return !this.agree;
    },
    accepted: function() {
      return this.acceptedLead !== null;
    },
    isOffered: function() {
      return this.lead.offered === 1;
    },
    actionedLeads: {
      get: function() {
        return this.$store.state.leads.ACTIONED_LEADS;
      },
      set: function(value) {
        this.$store.commit(ACTIONED_LEADS, value);
      }
    },
    printUrl: function() {
      return process.env.VUE_APP_DOWNLOAD_URL + 'lead/pdf/' + this.acceptedLead.code
    },
    company: function() {
      return this.$store.state.company.COMPANY;
    },
  },
  methods: {
    buyLead: function () {
      if (this.agree && this.canPayForLeads) {
        this.error = false;
        this.busy = true;
        this.$api.leads
          .buySingle(this.lead[0].id)
          .then((response) => {
            this.acceptedLead = response.data.data.lead;
            this.actionedLeads.push(this.lead[0].id);
            this.busy = false;
            this.$store.dispatch("accountBalance");
            this.logGaTransaction();
            this.fireEvent(this.acceptedLead, "accepted");
          })
          .catch((error) => {
            if (error.response.data.errors) {
              this.error = this.$errorMessages.getErrorMessage('lead_availability', error.response.data.errors[0]);
            } else {
              this.error = "There was an error while processing your request";
            }
            this.busy = false;
          });
      }
    },
    leadRejected: function() {
      this.actionedLeads.push(this.lead[0].id);
    },
    logGaTransaction: function() {
      this.logTransaction([this.acceptedLead], this.company, false);
    }
  },
  created: function() {
    this.survey = false;
    if (this.lead !== null) {
      this.$api.leads.getLeadQuestions(this.lead[0].id)
        .then((response) => {this.questions = response.data.data;});
    }
  }
}
</script>

<style scoped>

</style>
